import React, { Component } from 'react';
import '../css/App.css';
import API from '../config_api'
import axios from 'axios'
import Sidenav from './Sidenav';
import IdleTimerLogout from './IdleTimerLogout';
class Suggestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };

    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/')
        }
        let formData = new FormData();
        formData.append('token_id', localStorage.getItem('token'))
        axios({
            method: 'post',
            url: API.Suggestion,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                console.log(res.data.data)

                this.setState({ data: res.data.data })

            });
    }
    startUnit(program_id) {
        this.props.history.push('/units/' + program_id,{checklist:true})
    }
    render() {
        return (
            <div className="">
               
                {/* <Sidenav type={'second'} url={'/dashboard'} /> */}

                <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1
                    }}>
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.goBack()}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{fontSize:20}}> Documents</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>
                <div className="container">
                <div style={{position:'fixed',left:0,right:0,zIndex:1,background:'#F8F9FE'}}>
                        <div className="container">
                        <div className="row">
                           
                            {/* <div className="col-md-12 text-center" style={{ padding: 15 }}>
                                <h5 className="size-text">Documents</h5>
                            </div> */}
                        </div>
                      </div>
                      </div>
                      <div style={{height:95}}></div>
                    <div className="row">
                    {/* <div className="col-12">
                            <div className="card m-0 mb-3">
                                <p className="m-0" style={{fontSize:14}}>Do you have a great idea? Use the relevant form below to enter your idea and hit on FINISH. it will automatically be sent to an administrator for consideration.</p>
                            </div>
                        </div> */}
                        <div className="col-sm-12">
                            <div className="trans">
                                {this.state.data.map((data, index) =>
                                    <div className="unit_assign col-sm-12 " key={index} onClick={() => this.startUnit(data.program_id)}>
                                        <div className="col-sm-11 col-xs-11 pad_z">{data.title}</div>
                                        <div className="col-sm-1 col-xs-1 pad_z"><i className="material-icons">
                                            keyboard_arrow_right
</i></div>

                                    </div>)}
                            </div></div>
                    </div></div></div>
        )
    }
}
export default Suggestion;